import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const FeatureCard = ({
  icon: Icon,
  title,
  description,
  features = [],
  link,
  delay = 0
}) => {
  const CardWrapper = link ? motion(Link) : motion.div;
  const cardProps = link ? { to: link } : {};

  return (
    <CardWrapper
      {...cardProps}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ y: -5 }}
      className={`group ${link ? 'cursor-pointer' : ''}`}
      data-testid="feature-card"
    >
      <Card className="h-full border-warm-gray-200 hover:border-brand-maroon hover:shadow-soft-lg transition-all duration-300">
        <CardHeader>
          {Icon && (
            <div className="w-12 h-12 rounded-lg bg-brand-maroon/10 flex items-center justify-center mb-4 group-hover:bg-brand-maroon group-hover:scale-110 transition-all duration-300">
              <Icon className="w-6 h-6 text-brand-maroon group-hover:text-white" />
            </div>
          )}
          <CardTitle className="text-xl font-bold group-hover:text-brand-maroon transition-colors">
            {title}
          </CardTitle>
          <CardDescription className="text-muted-foreground">
            {description}
          </CardDescription>
        </CardHeader>
        {features.length > 0 && (
          <CardContent>
            <ul className="space-y-2">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start space-x-2 text-sm">
                  <Check className="w-4 h-4 text-brand-maroon flex-shrink-0 mt-0.5" />
                  <span className="text-muted-foreground">{feature}</span>
                </li>
              ))}
            </ul>
            {link && (
              <div className="mt-4 flex items-center text-brand-maroon font-medium text-sm group-hover:translate-x-1 transition-transform">
                Learn more <ArrowRight className="ml-1 w-4 h-4" />
              </div>
            )}
          </CardContent>
        )}
      </Card>
    </CardWrapper>
  );
};

export default FeatureCard;